import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.function.name";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import _slicedToArray from "/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { API_REQUEST } from '@/api';
import { getUniversalMutations, getUniversalGetters } from '@/common/store';
var LOAD_TEMPLATE_FETCH_LIMIT = 10;

var state = function state() {
  return {
    operations: [],
    operationTypeNames: [],
    loadTemplates: [],
    operationRelations: [],
    operationTemplates: [],
    fetchedRelationsIds: {}
  };
};

var mutations = _objectSpread(_objectSpread({}, getUniversalMutations(state())), {}, {
  resetFetchedRelationsIds: function resetFetchedRelationsIds(state) {
    state.fetchedRelationsIds = {};
  },
  clearOperationRelationByBaseId: function clearOperationRelationByBaseId(state, baseId) {
    state.operationRelations = state.operationRelations.filter(function (el) {
      return el.base.id !== baseId;
    });
  },
  addFetchedBaseIdRelation: function addFetchedBaseIdRelation(state, id) {
    state.fetchedRelationsIds = _objectSpread(_objectSpread({}, state.fetchedRelationsIds), {}, _defineProperty({}, id, true));
  }
});

var actions = {
  fetchLoadTemplates: function fetchLoadTemplates(_ref) {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, vuexState, _ref2, _ref2$force, force, next, i, _yield$API_REQUEST, _yield$API_REQUEST2, err, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, vuexState = _ref.state;
              _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref2$force = _ref2.force, force = _ref2$force === void 0 ? false : _ref2$force;
              _context.prev = 2;

              if (!(vuexState.loadTemplates.length && !force)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              next = true;
              i = 0;

            case 7:
              if (!next) {
                _context.next = 20;
                break;
              }

              _context.next = 10;
              return API_REQUEST('getLoadTemplate', {
                limit: LOAD_TEMPLATE_FETCH_LIMIT,
                offset: LOAD_TEMPLATE_FETCH_LIMIT * i
              });

            case 10:
              _yield$API_REQUEST = _context.sent;
              _yield$API_REQUEST2 = _slicedToArray(_yield$API_REQUEST, 2);
              err = _yield$API_REQUEST2[0];
              result = _yield$API_REQUEST2[1];

              if (!err) {
                _context.next = 16;
                break;
              }

              throw err;

            case 16:
              if (result) {
                next = !!result.next;
                commit('addLoadTemplates', {
                  items: result.results,
                  uniqueKey: 'id',
                  isForce: true
                });
              }

            case 17:
              i++;
              _context.next = 7;
              break;

            case 20:
              commit('application/setPrimaryPageLoaded', {
                value: true
              }, {
                root: true
              });
              console.log('fetchLoadTemplates', vuexState.loadTemplates);
              _context.next = 27;
              break;

            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](2);
              console.error('Unable to fetch load templates', _context.t0);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 24]]);
    }))();
  },
  fetchOperationTypeNames: function fetchOperationTypeNames(_ref3) {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, vuexState, _ref4, _ref4$force, force, _yield$API_REQUEST3, _yield$API_REQUEST4, err, result;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit, vuexState = _ref3.state;
              _ref4 = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {}, _ref4$force = _ref4.force, force = _ref4$force === void 0 ? false : _ref4$force;
              _context2.prev = 2;

              if (!(vuexState.operationTypeNames.length && !force)) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              _context2.next = 7;
              return API_REQUEST('getOperationTypeName');

            case 7:
              _yield$API_REQUEST3 = _context2.sent;
              _yield$API_REQUEST4 = _slicedToArray(_yield$API_REQUEST3, 2);
              err = _yield$API_REQUEST4[0];
              result = _yield$API_REQUEST4[1];

              if (!err) {
                _context2.next = 13;
                break;
              }

              throw err;

            case 13:
              if (result) {
                commit('setOperationTypeNames', {
                  items: result
                });
              }

              _context2.next = 19;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](2);
              console.error('Unable to fetch operation type names', _context2.t0);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 16]]);
    }))();
  },
  fetchOperationRelations: function fetchOperationRelations(_ref5) {
    var _arguments3 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var commit, vuexState, _ref6, base_id, depended_id, load_template, base_name_id, base_name, depended_name_id, depended_name, forecast_step, formula, ordering, limit, offset, _ref6$force, force, _yield$API_REQUEST5, _yield$API_REQUEST6, err, result;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref5.commit, vuexState = _ref5.state;
              _ref6 = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : {}, base_id = _ref6.base_id, depended_id = _ref6.depended_id, load_template = _ref6.load_template, base_name_id = _ref6.base_name_id, base_name = _ref6.base_name, depended_name_id = _ref6.depended_name_id, depended_name = _ref6.depended_name, forecast_step = _ref6.forecast_step, formula = _ref6.formula, ordering = _ref6.ordering, limit = _ref6.limit, offset = _ref6.offset, _ref6$force = _ref6.force, force = _ref6$force === void 0 ? false : _ref6$force;
              _context3.prev = 2;

              if (!(vuexState.fetchedRelationsIds[base_id] && !force)) {
                _context3.next = 5;
                break;
              }

              return _context3.abrupt("return");

            case 5:
              _context3.next = 7;
              return API_REQUEST('getOperationTypeRelation', {
                base_id: base_id,
                depended_id: depended_id,
                load_template: load_template,
                base_name_id: base_name_id,
                base_name: base_name,
                depended_name_id: depended_name_id,
                depended_name: depended_name,
                forecast_step: forecast_step,
                formula: formula,
                ordering: ordering,
                limit: limit,
                offset: offset
              });

            case 7:
              _yield$API_REQUEST5 = _context3.sent;
              _yield$API_REQUEST6 = _slicedToArray(_yield$API_REQUEST5, 2);
              err = _yield$API_REQUEST6[0];
              result = _yield$API_REQUEST6[1];

              if (!err) {
                _context3.next = 13;
                break;
              }

              throw err;

            case 13:
              if (result) {
                if (force) {
                  commit('clearOperationRelationByBaseId', base_id);
                }

                commit('addOperationRelations', {
                  items: result.results,
                  uniqueKey: 'id',
                  isForce: true
                });
              }

              commit('addFetchedBaseIdRelation', base_id);
              _context3.next = 20;
              break;

            case 17:
              _context3.prev = 17;
              _context3.t0 = _context3["catch"](2);
              console.error('Unable to fetch operation relations', _context3.t0);

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 17]]);
    }))();
  },
  getOperationRelations: function getOperationRelations(_ref7, _ref8) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var commit, vuexState, base_id, _ref8$force, force, _yield$API_REQUEST7, _yield$API_REQUEST8, err, result;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref7.commit, vuexState = _ref7.state;
              base_id = _ref8.base_id, _ref8$force = _ref8.force, force = _ref8$force === void 0 ? false : _ref8$force;
              _context4.prev = 2;

              if (!(vuexState.fetchedRelationsIds[base_id] && !force)) {
                _context4.next = 5;
                break;
              }

              return _context4.abrupt("return");

            case 5:
              _context4.next = 7;
              return API_REQUEST('getOperationTypeRelation', {
                base_id: base_id
              });

            case 7:
              _yield$API_REQUEST7 = _context4.sent;
              _yield$API_REQUEST8 = _slicedToArray(_yield$API_REQUEST7, 2);
              err = _yield$API_REQUEST8[0];
              result = _yield$API_REQUEST8[1];

              if (!err) {
                _context4.next = 13;
                break;
              }

              throw err;

            case 13:
              if (result) {
                commit('updateOperationRelations', {
                  items: result,
                  uniqueKey: 'id'
                });
              }

              commit('addFetchedBaseIdRelation', base_id);
              _context4.next = 20;
              break;

            case 17:
              _context4.prev = 17;
              _context4.t0 = _context4["catch"](2);
              console.error('Unable to get operation relations', _context4.t0);

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 17]]);
    }))();
  },
  createLoadTemplate: function createLoadTemplate(_ref9, payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var commit, apiMethod, _yield$API_REQUEST9, _yield$API_REQUEST10, err, result;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref9.commit;
              _context5.prev = 1;
              apiMethod = payload.file ? 'createLoadTemplateWithFile' : 'createLoadTemplate';
              _context5.next = 5;
              return API_REQUEST(apiMethod, payload);

            case 5:
              _yield$API_REQUEST9 = _context5.sent;
              _yield$API_REQUEST10 = _slicedToArray(_yield$API_REQUEST9, 2);
              err = _yield$API_REQUEST10[0];
              result = _yield$API_REQUEST10[1];

              if (!err) {
                _context5.next = 11;
                break;
              }

              throw err;

            case 11:
              if (!result) {
                _context5.next = 14;
                break;
              }

              commit('addLoadTemplates', {
                items: [result],
                uniqueKey: 'id',
                isForce: true
              });
              return _context5.abrupt("return", result);

            case 14:
              _context5.next = 19;
              break;

            case 16:
              _context5.prev = 16;
              _context5.t0 = _context5["catch"](1);
              console.error('Unable to fetch operation type names', _context5.t0);

            case 19:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 16]]);
    }))();
  },
  updateLoadTemplate: function updateLoadTemplate(_ref10, _ref11) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var commit, id, name, _yield$API_REQUEST11, _yield$API_REQUEST12, err, result, itemsToUpdate;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref10.commit;
              id = _ref11.id, name = _ref11.name;
              _context6.prev = 2;
              _context6.next = 5;
              return API_REQUEST('updateLoadTemplate', {
                id: id,
                name: name
              });

            case 5:
              _yield$API_REQUEST11 = _context6.sent;
              _yield$API_REQUEST12 = _slicedToArray(_yield$API_REQUEST11, 2);
              err = _yield$API_REQUEST12[0];
              result = _yield$API_REQUEST12[1];

              if (!err) {
                _context6.next = 11;
                break;
              }

              throw err;

            case 11:
              if (!result) {
                _context6.next = 15;
                break;
              }

              itemsToUpdate = Array.isArray(result) ? result : [result];
              commit('updateLoadTemplates', {
                items: itemsToUpdate,
                uniqueKey: 'id',
                isForce: true
              });
              return _context6.abrupt("return", result);

            case 15:
              _context6.next = 20;
              break;

            case 17:
              _context6.prev = 17;
              _context6.t0 = _context6["catch"](2);
              console.error('Unable to update load template', _context6.t0);

            case 20:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[2, 17]]);
    }))();
  },
  getLoadTemplate: function getLoadTemplate(_ref12, _ref13) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var commit, id, _yield$API_REQUEST13, _yield$API_REQUEST14, err, updatedTemplate, itemsToUpdate;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref12.commit;
              id = _ref13.id;
              _context7.next = 4;
              return API_REQUEST('getLoadTemplate', {
                id: id
              });

            case 4:
              _yield$API_REQUEST13 = _context7.sent;
              _yield$API_REQUEST14 = _slicedToArray(_yield$API_REQUEST13, 2);
              err = _yield$API_REQUEST14[0];
              updatedTemplate = _yield$API_REQUEST14[1];

              if (!(err || updatedTemplate === false)) {
                _context7.next = 10;
                break;
              }

              throw err || new Error('getLoadTemplate was not successful');

            case 10:
              itemsToUpdate = Array.isArray(updatedTemplate) ? updatedTemplate : [updatedTemplate];
              commit('updateLoadTemplates', {
                items: itemsToUpdate,
                uniqueKey: 'id',
                isForce: true
              });
              console.log('itemsToUpdate', itemsToUpdate);
              return _context7.abrupt("return", itemsToUpdate);

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  deleteOperation: function deleteOperation(_ref14, _ref15) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var dispatch, id, loadTemplateId, _yield$API_REQUEST15, _yield$API_REQUEST16, err, result, itemsToUpdate;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              dispatch = _ref14.dispatch;
              id = _ref15.id, loadTemplateId = _ref15.loadTemplateId;
              _context8.prev = 2;
              _context8.next = 5;
              return API_REQUEST('deleteOperationTypeTemplate', {
                id: id
              });

            case 5:
              _yield$API_REQUEST15 = _context8.sent;
              _yield$API_REQUEST16 = _slicedToArray(_yield$API_REQUEST15, 2);
              err = _yield$API_REQUEST16[0];
              result = _yield$API_REQUEST16[1];

              if (!(err || result === false)) {
                _context8.next = 11;
                break;
              }

              throw err || new Error('deleteOperationTypeTemplate was not successful');

            case 11:
              _context8.next = 13;
              return dispatch('getLoadTemplate', {
                id: loadTemplateId
              });

            case 13:
              itemsToUpdate = _context8.sent;
              return _context8.abrupt("return", itemsToUpdate);

            case 17:
              _context8.prev = 17;
              _context8.t0 = _context8["catch"](2);
              console.error('Unable to delete operation', _context8.t0);

            case 20:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[2, 17]]);
    }))();
  },
  deleteOperationRelation: function deleteOperationRelation(_, _ref16) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var id, _yield$API_REQUEST17, _yield$API_REQUEST18, err, result;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              id = _ref16.id;
              _context9.prev = 1;
              _context9.next = 4;
              return API_REQUEST('deleteOperationTypeRelation', {
                id: id
              });

            case 4:
              _yield$API_REQUEST17 = _context9.sent;
              _yield$API_REQUEST18 = _slicedToArray(_yield$API_REQUEST17, 2);
              err = _yield$API_REQUEST18[0];
              result = _yield$API_REQUEST18[1];

              if (!(err || result === false)) {
                _context9.next = 10;
                break;
              }

              throw err || new Error('deleteOperationTypeRelation was not successful');

            case 10:
              return _context9.abrupt("return", result);

            case 13:
              _context9.prev = 13;
              _context9.t0 = _context9["catch"](1);
              console.error('Unable to delete operation relation', _context9.t0);

            case 16:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[1, 13]]);
    }))();
  },
  createOperationTypeTemplate: function createOperationTypeTemplate(_ref17, _ref18) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var dispatch, loadTemplateId, payload, _yield$API_REQUEST19, _yield$API_REQUEST20, err, result, itemsToUpdate;

      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              dispatch = _ref17.dispatch;
              loadTemplateId = _ref18.loadTemplateId, payload = _ref18.payload;
              _context10.prev = 2;
              _context10.next = 5;
              return API_REQUEST('createOperationTypeTemplate', payload);

            case 5:
              _yield$API_REQUEST19 = _context10.sent;
              _yield$API_REQUEST20 = _slicedToArray(_yield$API_REQUEST19, 2);
              err = _yield$API_REQUEST20[0];
              result = _yield$API_REQUEST20[1];

              if (!(err || result === false)) {
                _context10.next = 11;
                break;
              }

              throw err || new Error('createOperationTypeTemplate was not successful');

            case 11:
              _context10.next = 13;
              return dispatch('getLoadTemplate', {
                id: loadTemplateId
              });

            case 13:
              itemsToUpdate = _context10.sent;
              return _context10.abrupt("return", itemsToUpdate);

            case 17:
              _context10.prev = 17;
              _context10.t0 = _context10["catch"](2);
              console.error('Unable to create operation type template', _context10.t0);

            case 20:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[2, 17]]);
    }))();
  },
  updateOperationTypeTemplate: function updateOperationTypeTemplate(_ref19, _ref20) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var dispatch, loadTemplateId, payload, _yield$API_REQUEST21, _yield$API_REQUEST22, err, result, itemsToUpdate;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              dispatch = _ref19.dispatch;
              loadTemplateId = _ref20.loadTemplateId, payload = _ref20.payload;
              _context11.prev = 2;
              _context11.next = 5;
              return API_REQUEST('updateOperationTypeTemplate', payload);

            case 5:
              _yield$API_REQUEST21 = _context11.sent;
              _yield$API_REQUEST22 = _slicedToArray(_yield$API_REQUEST21, 2);
              err = _yield$API_REQUEST22[0];
              result = _yield$API_REQUEST22[1];

              if (!(err || result === false)) {
                _context11.next = 11;
                break;
              }

              throw err || new Error('updateOperationTypeTemplate was not successful');

            case 11:
              _context11.next = 13;
              return dispatch('getLoadTemplate', {
                id: loadTemplateId
              });

            case 13:
              itemsToUpdate = _context11.sent;
              return _context11.abrupt("return", itemsToUpdate);

            case 17:
              _context11.prev = 17;
              _context11.t0 = _context11["catch"](2);
              console.error('Unable to update operation type template', _context11.t0);

            case 20:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[2, 17]]);
    }))();
  },
  updateOperationTypeRelation: function updateOperationTypeRelation(_ref21, _ref22) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
      var dispatch, loadTemplateId, payload, _yield$API_REQUEST23, _yield$API_REQUEST24, err, result, itemsToUpdate;

      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              dispatch = _ref21.dispatch;
              loadTemplateId = _ref22.loadTemplateId, payload = _ref22.payload;
              _context12.prev = 2;
              _context12.next = 5;
              return API_REQUEST('updateOperationTypeRelation', payload);

            case 5:
              _yield$API_REQUEST23 = _context12.sent;
              _yield$API_REQUEST24 = _slicedToArray(_yield$API_REQUEST23, 2);
              err = _yield$API_REQUEST24[0];
              result = _yield$API_REQUEST24[1];

              if (!(err || result === false)) {
                _context12.next = 11;
                break;
              }

              throw err || new Error('updateOperationTypeRelation was not successful');

            case 11:
              _context12.next = 13;
              return dispatch('getLoadTemplate', {
                id: loadTemplateId
              });

            case 13:
              itemsToUpdate = _context12.sent;
              _context12.next = 16;
              return dispatch('getOperationRelations', {
                base_id: payload.base_id,
                force: true
              });

            case 16:
              return _context12.abrupt("return", itemsToUpdate);

            case 19:
              _context12.prev = 19;
              _context12.t0 = _context12["catch"](2);
              console.error('Unable to update operation type relation', _context12.t0);

            case 22:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[2, 19]]);
    }))();
  },
  createOperationTypeRelation: function createOperationTypeRelation(_ref23, _ref24) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
      var dispatch, loadTemplateId, payload, _yield$API_REQUEST25, _yield$API_REQUEST26, err, result, itemsToUpdate;

      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              dispatch = _ref23.dispatch;
              loadTemplateId = _ref24.loadTemplateId, payload = _ref24.payload;
              _context13.prev = 2;
              _context13.next = 5;
              return API_REQUEST('createOperationTypeRelation', payload);

            case 5:
              _yield$API_REQUEST25 = _context13.sent;
              _yield$API_REQUEST26 = _slicedToArray(_yield$API_REQUEST25, 2);
              err = _yield$API_REQUEST26[0];
              result = _yield$API_REQUEST26[1];

              if (!(err || result === false)) {
                _context13.next = 11;
                break;
              }

              throw err || new Error('createOperationTypeRelation was not successful');

            case 11:
              _context13.next = 13;
              return dispatch('getLoadTemplate', {
                id: loadTemplateId
              });

            case 13:
              itemsToUpdate = _context13.sent;
              return _context13.abrupt("return", itemsToUpdate);

            case 17:
              _context13.prev = 17;
              _context13.t0 = _context13["catch"](2);
              console.error('Unable to create operation type relation', _context13.t0);

            case 20:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[2, 17]]);
    }))();
  },
  applyLoadTemplate: function applyLoadTemplate(_, _ref25) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
      var id, _yield$API_REQUEST27, _yield$API_REQUEST28, err, result;

      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              id = _ref25.id;
              _context14.prev = 1;
              _context14.next = 4;
              return API_REQUEST('loadTemplateApply', {
                id: id
              });

            case 4:
              _yield$API_REQUEST27 = _context14.sent;
              _yield$API_REQUEST28 = _slicedToArray(_yield$API_REQUEST27, 2);
              err = _yield$API_REQUEST28[0];
              result = _yield$API_REQUEST28[1];

              if (!(err || result === false)) {
                _context14.next = 10;
                break;
              }

              throw err || new Error('loadTemplateApply was not successful');

            case 10:
              return _context14.abrupt("return", result);

            case 13:
              _context14.prev = 13;
              _context14.t0 = _context14["catch"](1);
              console.error('Unable to delete operation relation', _context14.t0);

            case 16:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[1, 13]]);
    }))();
  }
};

var getters = _objectSpread(_objectSpread({}, getUniversalGetters(state())), {}, {
  operationTemplatesByTemplateId: function operationTemplatesByTemplateId(vuexState) {
    return vuexState.loadTemplates.reduce(function (acc, template) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, template.id, template.operation_type_templates));
    }, {});
  },
  operationRelationsByBaseId: function operationRelationsByBaseId(vuexState) {
    return vuexState.operationRelations.filter(function (el) {
      return el.base;
    }).reduce(function (acc, el) {
      if (acc[el.base.id]) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, el.base.id, [].concat(_toConsumableArray(acc[el.base.id]), [el])));
      }

      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, el.base.id, [el]));
    }, {});
  }
});

export default {
  namespaced: true,
  mutations: mutations,
  actions: actions,
  getters: getters,
  state: state
};